// https://github.com/ljharb/proposal-global
var $export = require(32);

$export($export.S, 'System', {global: require(38)});